import {
  FascicoloAutoritaIndipendentiRegolatorie
} from "../../../../autorita-indipendente/fascicoloFormShared/models/autorita-indipendente-regolatorie/fascicolo-autorita-indipendenti-regolatorie";
import {
  FormAutoritaIndipendentiRegolatorieComponent
} from "../../../../autorita-indipendente/fascicoloFormShared/form-autorita-indipendenti-regolatorie/form-autorita-indipendenti-regolatorie.component";
import {
  FormAutoritaIndipendentiRegolatorieViewComponent
} from "../../../../autorita-indipendente/fascicoloFormShared/form-autorita-indipendenti-regolatorie/view/form-autorita-indipendenti-regolatorie-view.component";
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from "../../../../autorita-indipendente/fascicoloFormShared/form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component";
import {
  FormRecuperoCreditiStragiudizialeComponent
} from "../../../../autorita-indipendente/fascicoloFormShared/form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component";
import {
  FascicoloRecuperoCreditiStragiudiziale
} from "../../../../autorita-indipendente/fascicoloFormShared/models/recupero-crediti-stragiudiziale/fascicolo-recuperocreditistragiudiziale";


export function getComponentFromFormTenantAutoritaInd(idFormTenant, view = false) {
  switch (idFormTenant) {
    case 'AutAut_PRD': {
      // AUTORITAINDIPENDENTI E REGOLATORIE
      return view ? FormAutoritaIndipendentiRegolatorieViewComponent : FormAutoritaIndipendentiRegolatorieComponent;
    }
    case 'AutRec_PRD': {
      // RECUPERO CREDITI STRAGIUDIZIALE
      return view ? FormRecuperoCreditiStragiudizialeViewComponent : FormRecuperoCreditiStragiudizialeComponent;
    }
  }
}

export function getFascicoloAutoritaInd(genericFascicolo): any {
  switch (genericFascicolo) {
    case 'autorita': {
      return new FascicoloAutoritaIndipendentiRegolatorie();
    }
    case 'recuperocreditistragiudiziale': {
      return new FascicoloRecuperoCreditiStragiudiziale();
    }
  }
}
